import React from 'react';

import {
    IntroHolder,
    TwoColumns,
    Sidebar,
    Content,
} from '@bahaide/shared/components/InnerPage';
import { YouTube } from '@bahaide/shared/components/YouTube';

import InnerPage from '../../components/InnerPage';

const PodcastsVideosPage = () => (
    <InnerPage title="Podcasts und Videos">
        <IntroHolder
            title="Podcasts und Videos"
            breadcrumbs={{
                'current-item': 'Podcasts und Videos',
            }}
        ></IntroHolder>

        <TwoColumns>
            <Content>
                <h2 className="h4">Podcast</h2>
                <p>
                    „Einblicke in…“ … diverse Themen, Gesprächsrunden, oder
                    Entwicklungen in der Bahá’í-Gemeinde
                </p>
                <br />
                <div>
                    <iframe
                        width="100%"
                        height="480"
                        scrolling="no"
                        frameborder="no"
                        allow="autoplay"
                        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/848390255&color=%234a7eb5&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"
                    ></iframe>
                </div>
                <h2 className="h4">Videos</h2>
                <p>
                    Folgen Sie Erkenntnissen und Erfahrungen aus dem Spektrum
                    der Bemühungen der Bahá'i-Gemeinde gemeinsam mit weiteren
                    Akteuren zu gesellschaftlichem Zusammenhalt beizutragen:
                </p>
                <br />
                <YouTube id="w-tuoO-uoAk" />
                <br />
                <YouTube id="4QKIEfNWk3U" />
                <br />
                <YouTube id="bYc_lHjGEzk" />
                <br />
                <YouTube id="LjTAhioqbwk" />
                <br />
                <YouTube id="iS-PQk5iYPU" />
                <br />
                <YouTube id="VBc-wB7bQJY" />
                <br />
                <YouTube id="kn4rhV7-stE" />
                <br />
                <YouTube id="iOnhRmYrGyc" />
                <br />
                <YouTube id="B2ZmmXoAOjQ" />
                <br />
                <YouTube id="Fl5ytOPFuZI" />
                <br />
                <YouTube id="tdFY_lVXzeQ" />
                <br />
                <YouTube id="0BGjsX5LvCg" />
                <br />
                <YouTube id="8jAT2g9pB2k" />
                <br />
                <YouTube id="T6mpq_3viwY" />
            </Content>
            <Sidebar />
        </TwoColumns>
    </InnerPage>
);

export default PodcastsVideosPage;
